import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as Text from "@/components/text";

const sizes = {
  sm: "",
  md: "px-5 py-1",
};

export default function AnchorChip({
  size = "md",
  active = false,
  children,
  ...rest
}) {
  const css = classNames(
    sizes[size],
    "flex b-radi rounded-2xl border border-neutral-300 hover:border-transparent text-neutral-700 justify-center hover:bg-neutral-900 hover:text-neutral-50 cursor-pointer",
    active ? "bg-neutral-900 text-white" : "bg-transparent text-neutral-700"
  );
  return (
    <div {...rest} className={css}>
      <Text.Label size={size}>{children}</Text.Label>
    </div>
  );
}

AnchorChip.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  active: PropTypes.bool,
};
